import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseHttpClient } from "./BaseHttpClient";

@Injectable({
    providedIn: 'root'
})
export abstract class ClickkerHttpClient implements BaseHttpClient {
    private http: HttpClient = inject(HttpClient);
    private baseUrl: string;
    private includeCredentials: boolean;

    constructor(baseUrl: string, includeCredentials: boolean = true) {
        this.baseUrl = baseUrl;
        this.includeCredentials = includeCredentials;
    }

    public get<T>(endpoint: string): Observable<T> {
        const url = this.baseUrl + endpoint;
        return this.http.get<T>(url, {withCredentials: this.includeCredentials, headers: this.getHeaders()});
    }

    public post<T>(endpoint: string, body: any): Observable<T> {
        const url = this.baseUrl + endpoint;
        return this.http.post<T>(url, body, {withCredentials: this.includeCredentials, headers: this.getHeaders()});
    }

    public put<T>(endpoint: string, body: any): Observable<T> {
        const url = this.baseUrl + endpoint;
        return this.http.put<T>(url, body, {withCredentials: this.includeCredentials, headers: this.getHeaders()});
    }

    public patch<T>(endpoint: string, body: any): Observable<T> {
        const url = this.baseUrl + endpoint;
        return this.http.patch<T>(url, body, {withCredentials: this.includeCredentials, headers: this.getHeaders()});
    }

    public delete<T>(endpoint: string): Observable<T> {
        const url = this.baseUrl + endpoint;
        return this.http.delete<T>(url, {withCredentials: this.includeCredentials, headers: this.getHeaders()});
    }

    protected getHeaders(): HttpHeaders | undefined {
        return undefined;
    }
}
